var _mask, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9490_513",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.706055H15.1998V6.52424V16.7061H6.54526H0.799805V11.1303V6.52424V0.706055Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 12.1303H6.54526V10.1303H0.799805V12.1303ZM0.799805 7.52424H6.54526V5.52424H0.799805V7.52424ZM6.54526 7.52424H15.1998V5.52424H6.54526V7.52424ZM7.54526 11.1303V6.52424H5.54526V11.1303H7.54526ZM7.54526 16.7061V11.1303H5.54526V16.7061H7.54526ZM0.799805 0.706055V-1.29395H-1.2002V0.706055H0.799805ZM15.1998 0.706055H17.1998V-1.29395H15.1998V0.706055ZM15.1998 16.7061V18.7061H17.1998V16.7061H15.1998ZM0.799805 16.7061H-1.2002V18.7061H0.799805V16.7061ZM0.799805 2.70605H15.1998V-1.29395H0.799805V2.70605ZM2.7998 6.52424V0.706055H-1.2002V6.52424H2.7998ZM13.1998 0.706055V6.52424H17.1998V0.706055H13.1998ZM13.1998 6.52424V16.7061H17.1998V6.52424H13.1998ZM2.7998 16.7061V11.1303H-1.2002V16.7061H2.7998ZM2.7998 11.1303V6.52424H-1.2002V11.1303H2.7998ZM15.1998 14.7061H6.54526V18.7061H15.1998V14.7061ZM6.54526 14.7061H0.799805V18.7061H6.54526V14.7061Z",
    fill: "#014780",
    mask: "url(#path-1-inside-1_9490_513)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDashboardIcon);
export default __webpack_public_path__ + "static/media/view_dashboard_icon.4f311499.svg";
export { ForwardRef as ReactComponent };